import React, { Suspense, useEffect } from 'react'
import ErrorBoundary from '../ErrorBoundary'
import ErrorHtml from '../ErrorBoundary/error'
// import IconLoading from '../IconLoading'
import Loading from '../Loading' // <Loading />
// import RooLoading from '@roo/roo/Loading' // <RooLoading visible fullscreen />

const LoadingHtml = <Loading />

const handleError = () => {}

export default function (route: RouteConfigVo) {
  const {
    component: Component,
    fallback = LoadingHtml,
    errorBoundaryFallback = ErrorHtml,
    onError,
    path,
    routes,
    pvPageType,
    ...otherRoute
  } = route || {}

  useEffect(() => {

  }, [])

  return (
    <ErrorBoundary fallback={errorBoundaryFallback || ErrorHtml} onError={() => (onError || handleError)()}>
      <Suspense fallback={fallback}>
        <Component {...otherRoute} routes={routes} />
      </Suspense>
    </ErrorBoundary>
  )
}
